import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { formatDate, formatMoney, roundToTwoDecimals } from "../Helpers";

export default function View({ data, studentUuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */

	function view() {
		
		appContext.navTo({
			item: 'side-view',
			subItem: 'view-student-exam-cycle-result',
			extraItem: studentUuid,
			moreItem: data.examCycleData.uuid,
		})
	}

	return (
		<div className="One" onClick={view}>
			<div className="row">

				<div className="col-12 mb-4">
					<h6
						style={{
							fontSize: "16px"
						}}
						className="font-semi-bold"
					>
						{data.examCycleData.title}
					</h6>
				</div>
				
				<div className="col-6 col-md-3 mb-2 mt-2">
					<label className="form-label text-muted">Average</label>
					<h6
						style={{
							fontSize: "18px"
						}}
						className="font-regular"
					>
						{(data.average !== null) ? roundToTwoDecimals(data.average) : "N/A"}
					</h6>
				</div>

				<div className="col-6 col-md-3 mb-2 mt-2">
					<label className="form-label text-muted">Position</label>
					<h6
						style={{
							fontSize: "18px"
						}}
						className="font-regular"
					>
						{(data.position !== null) ? data.position : "N/A"}
					</h6>
				</div>

				<div className="col-6 col-md-3 mb-2 mt-2">
					<label className="form-label text-muted">Division</label>
					<h6
						style={{
							fontSize: "18px"
						}}
						className="font-regular"
					>
						{(data.division || "N/A")}
					</h6>
				</div>

				<div className="col-6 col-md-3 mb-2 mt-2">
					<label className="form-label text-muted">Points</label>
					<h6
						style={{
							fontSize: "18px"
						}}
						className="font-regular"
					>
						{(data.points || "N/A")}
					</h6>
				</div>
				
				<div className="col-12">
					<hr/>
				</div>

			</div>
		</div>
	)

}